export interface LeadInput {
  id?: string;
  name: string;
  phone: string;
  email?: string;
}

export interface CreateRunPayload {
  name: string;
  assistant_id: string;
  leads: LeadInput[];
  context?: string;
  campaign_id?: string | null;
  goals?: string;
  target_audience?: string;
  call_objective?: string;
  success_metrics?: string;
  agent_name?: string;
  voice_id?: string;
  custom_fields?: Array<{ title: string; value: string }>;
  scheduled_at?: string;
  // LT-380: surfaces runs.pin_agent_version_at_launch (LT-342 column,
  // default true). Operator toggles to false → run uses latest agent
  // version at dispatch (no snapshot pin).
  pin_agent_version_at_launch?: boolean;
}

export function buildCreateRunPayload(
  name: string,
  assistantId: string,
  leads: LeadInput[],
  context?: string,
  campaignId?: string | null,
  goals?: string,
  targetAudience?: string,
  callObjective?: string,
  successMetrics?: string,
  agentName?: string,
  customFields?: Array<{ title: string; value: string }>,
  voiceId?: string,
  scheduledAt?: string,
  // LT-380: pin-agent-version toggle. Optional so existing callers can
  // omit and inherit the backend default (true). Pass false to opt out
  // of the launch-time version snapshot.
  pinAgentVersionAtLaunch?: boolean,
): CreateRunPayload {
  return {
    name: name.trim(),
    assistant_id: assistantId,
    leads,
    context: context?.trim() || undefined,
    campaign_id: campaignId ?? undefined,
    goals: goals?.trim() || undefined,
    target_audience: targetAudience?.trim() || undefined,
    call_objective: callObjective?.trim() || undefined,
    success_metrics: successMetrics?.trim() || undefined,
    agent_name: agentName?.trim() || undefined,
    custom_fields: customFields && customFields.length > 0 ? customFields : undefined,
    voice_id: voiceId?.trim() || undefined,
    scheduled_at: scheduledAt || undefined,
    pin_agent_version_at_launch: pinAgentVersionAtLaunch,
  };
}

// Conversation payloads
export interface StartConversationPayload {
  assistant_id?: string;
  customer_id?: string;
}

export function buildStartConversationPayload(
  assistantId?: string,
  customerId?: string
): StartConversationPayload {
  const payload: StartConversationPayload = {};
  if (assistantId) payload.assistant_id = assistantId;
  if (customerId) payload.customer_id = customerId;
  return payload;
}

export const buildPersistentWebCallPayload = buildStartConversationPayload;

// Billing payloads
export interface SubscribePayload { plan_id: string; }
export const buildSubscribePayload = (planId: string): SubscribePayload => ({ plan_id: planId });

export interface AddCreditsPayload { credits: number; }
export const buildAddCreditsPayload = (credits: number): AddCreditsPayload => ({ credits });

export const buildCreateCustomerPayload = (): Record<string, never> => ({});


